module.exports = __webpack_public_path__ + "img/back.fa99e2a1.png";